export type LiveSpeechSessionErrorCode =
  | "week_limit_exceeded"
  | "liveavatar_unavailable"
  | "realtime_error"
  | "disconnect"
  | "connect_error"
  | "ai_dialogue_timeout";

export type LiveSpeechSessionError = {
  code: LiveSpeechSessionErrorCode;
  message: string;
  retryable: boolean;
  canFallbackAudioOnly: boolean;
};

export const AI_DIALOGUE_START_TIMEOUT_MS = 30_000;

export const OFFLINE_SESSION_ERROR: LiveSpeechSessionError = {
  code: "connect_error",
  message: "No internet connection. Check your network and try again.",
  retryable: true,
  canFallbackAudioOnly: true,
};

export function isBrowserOffline(): boolean {
  return typeof navigator !== "undefined" && navigator.onLine === false;
}

export function mapResponseError(
  raw: unknown,
): LiveSpeechSessionError | null {
  if (typeof raw !== "string" || !raw.trim()) return null;
  const normalized = raw.trim().toLowerCase();

  if (normalized === "week limit exceeded") {
    return {
      code: "week_limit_exceeded",
      message:
        "Weekly limit reached. You can close this session and try again next week.",
      retryable: false,
      canFallbackAudioOnly: false,
    };
  }

  if (normalized === "liveavatar_unavailable") {
    return {
      code: "liveavatar_unavailable",
      message:
        "Avatar is unavailable. You can continue with audio only or end the session.",
      retryable: false,
      canFallbackAudioOnly: true,
    };
  }

  return {
    code: "realtime_error",
    message: raw,
    retryable: true,
    canFallbackAudioOnly: false,
  };
}
